import src from "IMAGE";
export default { src, width: 1157, height: 88, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAsSHWYKERpcChAaWyAnL1Ssw9Tewd3y/8Pe8v+/2Ov2rKIQRS/tUg8AAAAASUVORK5CYII="};
